export default __webpack_public_path__ + "static/media/homeScene_6.ffc1255d.png";